"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerPublicationMethod = void 0;
var ProducerPublicationMethod;
(function (ProducerPublicationMethod) {
    ProducerPublicationMethod["YoutubeLinkPublication"] = "youtubeLinkPublication";
    ProducerPublicationMethod["YoutubeConnectionPublication"] = "youtubeConnectionPublication";
    ProducerPublicationMethod["SelfHostingPublication"] = "selfHostingPublication";
    ProducerPublicationMethod["ClipsOnlyPublication"] = "clipsOnlyPublication";
})(ProducerPublicationMethod = exports.ProducerPublicationMethod || (exports.ProducerPublicationMethod = {}));
//# sourceMappingURL=producer-publication-method.js.map